import React from "react";
import { useBrand } from "../context/BrandContext";

const FALLBACK =
  "https://customer-assets.emergentagent.com/job_infinity-manage/artifacts/mtksx1dv_Infinity-DMS_LOGO-3.jpg";

export const Logo = ({ className = "", variant = "dark" }) => {
  const { logo_url } = useBrand();
  const textColor = variant === "light" ? "#ffffff" : "#f5ecd9";
  const subColor = "#a8b2cc";

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <div
        className="h-12 w-[72px] rounded-xl overflow-hidden bg-[#0b0f1a] flex items-center justify-center relative shrink-0"
        style={{
          boxShadow:
            "0 0 0 1px rgba(245,236,217,0.06), 0 0 28px rgba(85,162,210,0.28)",
        }}
      >
        <img
          src={logo_url || FALLBACK}
          alt="Infinity DMS — Infinity Data & Mobile Solutions"
          className="w-full h-full object-contain p-1"
          loading="eager"
        />
      </div>
      <div className="leading-none">
        <div
          className="font-display text-[1.2rem] tracking-tighter"
          style={{ color: textColor }}
        >
          INFINITY<span className="rainbow-text">.</span>DMS
        </div>
        <div
          className="font-nav text-[0.6rem] uppercase tracking-[0.22em] mt-1.5 font-semibold"
          style={{ color: subColor }}
        >
          Data &amp; Mobile Solutions
        </div>
      </div>
    </div>
  );
};

export default Logo;
